/* AlwaysClean — animations au scroll (aucune dépendance, ~1 Ko)
   Marque les éléments hors écran avec [data-acr], puis .ac-in à l'entrée
   dans le viewport. Nettoie les attributs une fois la transition finie
   pour ne pas interférer avec les effets :hover des cartes. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!('IntersectionObserver' in window)) return;

  var GROUPS = [
    '.ac-probleme__header', '.ac-quiz__header',
    '.ac-packs__header', '.ac-prodcards__header',
    '.ac-benef__header', '.ac-temoignages__header', '.ac-faq__header',
    '.ac-garantie__header', '.ac-securite__content', '.ac-securite__media',
    '.ac-specs__header',
    '.ac-quiz__card', '.ac-faq__contact', '.ac-garantie__cta',
    '.ac-packs__note', '.ac-prodcards__note'
  ];
  var ITEMS = [
    '.ac-probleme__col', '.ac-packs__card', '.ac-prodcards__card',
    '.ac-benef__step', '.ac-temoignages__card', '.ac-garantie__item',
    '.ac-faq__item', '.ac-specs__item'
  ];

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      io.unobserve(el);
      el.classList.add('ac-in');
      var cleanup = function () {
        el.removeAttribute('data-acr');
        el.classList.remove('ac-in');
        el.style.removeProperty('--acr-delay');
        el.removeEventListener('transitionend', cleanup);
      };
      el.addEventListener('transitionend', cleanup);
      setTimeout(cleanup, 1600);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

  function prep(el, delay) {
    var rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 0.92 && rect.bottom > 0) return;
    el.setAttribute('data-acr', '');
    if (delay) el.style.setProperty('--acr-delay', delay + 'ms');
    io.observe(el);
  }

  function init() {
    GROUPS.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { prep(el, 0); });
    });
    ITEMS.forEach(function (sel) {
      var counts = [];
      document.querySelectorAll(sel).forEach(function (el) {
        var parent = el.parentElement;
        var entry = null;
        for (var i = 0; i < counts.length; i++) {
          if (counts[i].parent === parent) { entry = counts[i]; break; }
        }
        if (!entry) { entry = { parent: parent, n: 0 }; counts.push(entry); }
        prep(el, Math.min(entry.n * 90, 360));
        entry.n += 1;
      });
    });
    document.documentElement.classList.add('ac-motion');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
